import React from 'react';
import './loading.scss';

interface LoadingProps {
  fullScreen?: boolean;
}

const Loading = ({ fullScreen = true }: LoadingProps) => {
  return (
    <div
      className={`loading-container ${fullScreen ? 'fullscreen' : 'inline'}`}
    >
      <div className="spinner">
        <div className="spinner-circle" />
      </div>
      <p className="loading-text">Cargando...</p>
    </div>
  );
};

export default Loading;
